/**
 * True when stories-app is running as a module inside the PSP shell. Reads the
 * window stash pspEntry.mount() sets — NOT bnp-core's isPspMode(), because we
 * deliberately leave bnp-core in standalone mode (URLs stay relative for
 * same-origin local-dev).
 */
export function isPspMounted(): boolean {
  return (
    typeof window !== 'undefined' &&
    (window as unknown as { __OG_STORIES_PSP_OPTIONS__?: unknown }).__OG_STORIES_PSP_OPTIONS__ != null
  );
}
